<div class="container">
  <div
    gdAreas="filters products | filters products "
    gdAreas.lt-md="filters | products"
    gdColumns="1fr 3fr"
    gdColumns.sm="repeat(auto-fill, minmax( 400px, 2fr))"
    gdColumns.xs="repeat(auto-fill, minmax(200px, 1fr))"
    gdGap="16px"
    gdRows="auto auto auto auto"
  >
    <div gdArea="filters">
      <div fxLayout="column" fxLayout.lt-md="column">
        <div fxFlex.lt-md="100">
          <app-categories-display></app-categories-display>
        </div>
      </div>
    </div>

    <div gdArea="products">
      <div fxLayout="column" fxLayoutAlign="center center">
        <h1 *ngIf="isCategoryFiltered" class="primary">{{ categoryTitle }}</h1>
        <h1 *ngIf="!isCategoryFiltered" class="primary">
          Tous les outils d'intervention
        </h1>
      </div>
      <ng-container *ngIf="products$ | async as products">
        <div fxLayout="column" fxLayoutAlign="center center">
          <ng-container *ngIf="products.length === 0">
            <h2 class="accent">Aucun produit dans cette catégorie</h2>
            <h2 class="accent">
              Revenez plus tard ou partagez vos créations :)
            </h2>
          </ng-container>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="16px grid">
          <div
            *ngFor="
              let product of products
                | paginate
                  : {
                      id: 'category',
                      itemsPerPage: productsPerPage,
                      currentPage: page,
                      totalItems: totalProducts
                    };
              trackBy: productService.trackByProductID
            "
            fxFlex="25"
            fxFlex.lt-md="50"
          >
            <app-product-card [product]="product"></app-product-card>
          </div>
          <br />
        </div>
        <div fxLayout="row" fxLayoutAlign="center center">
          <app-custom-pagination-controls
            (pageChange)="getProductsForPage($event)"
            [autoHide]="true"
            [id]="'category'"
            [nextLabel]="'Page Suivante'"
            [previousLabel]="'Page Précédente'"
            [responsive]="true"
            class="my-pagination"
          >
          </app-custom-pagination-controls>
        </div>
      </ng-container>
    </div>
  </div>
</div>
